var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#57A6DD;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#221F20;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFCA05;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#00A4DF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#EE4123;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st7{fill:#305692;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#F7A600;}\n\t.st9{fill:#F2F2F2;}\n\t.st10{fill:#FF5F00;}\n\t.st11{fill:#EB001B;}\n\t.st12{fill:#F79E1B;}\n\t.st13{fill:#BC2B2B;}\n");
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M50.99,40H7.01C3.15,40,0,36.85,0,32.99V7.01C0,3.15,3.15,0,7.01,0h43.98C54.85,0,58,3.15,58,7.01v25.98 C58,36.85,54.85,40,50.99,40z"
}), /*#__PURE__*/React.createElement("g", {
  id: "_Group_3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24.29,
  y: 11.47,
  className: "st10",
  width: 9.44,
  height: 17
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_3",
  className: "st11",
  d: "M24.86,20.01c0-3.33,1.55-6.43,4.15-8.54c-4.72-3.66-11.47-2.85-15.21,1.79 c-3.66,4.72-2.85,11.47,1.79,15.21c3.9,3.09,9.44,3.09,13.34,0C26.4,26.43,24.86,23.34,24.86,20.01z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M46.5,20.01c0,5.94-4.8,10.82-10.82,10.82c-2.44,0-4.8-0.81-6.67-2.28c4.72-3.66,5.53-10.49,1.79-15.13 c-0.57-0.65-1.14-1.3-1.79-1.79c4.72-3.66,11.47-2.85,15.13,1.79C45.68,15.21,46.5,17.57,46.5,20.01z M45.44,26.68v-0.33h0.16 v-0.08h-0.33v0.08h0.16V26.68L45.44,26.68z M46.17,26.68v-0.41h-0.08l-0.16,0.33l-0.16-0.33h-0.08v0.41h0.08v-0.33l0.16,0.24h0.08 l0.08-0.24v0.33H46.17z"
})));
function SvgMaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 40",
    style: {
      enableBackground: "new 0 0 58 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.0b46bd9c5cb34e3a354ea7f423c7cf78.svg";
export { ForwardRef as ReactComponent };